export default {
  referFriends: {
    en: 'Refer friends and get free {gender, select, female {perfume} male {cologne}}',
  },
}
